import { render, staticRenderFns } from "./IconTextBackground.vue?vue&type=template&id=738d3181&"
import script from "./IconTextBackground.vue?vue&type=script&lang=js&"
export * from "./IconTextBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('738d3181')) {
      api.createRecord('738d3181', component.options)
    } else {
      api.reload('738d3181', component.options)
    }
    module.hot.accept("./IconTextBackground.vue?vue&type=template&id=738d3181&", function () {
      api.rerender('738d3181', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconTextBackground.vue"
export default component.exports